import { generateMockMatter } from "@/lib/data/factories/matter-factory";
import type { Matter } from "@/lib/types";

/**
 * `buildTemplateDictionaryOptions` expects a full `Matter` shape. For global
 * firm-tab flows we have no matter row; this stub has empty collections and
 * blank strings so matter-backed dropdowns are empty while firm/office fields
 * still resolve from `firm` / `firmOffices` in the builder.
 */
export function getEmptyMatterForFirmTemplateMapping(): Matter {
  return generateMockMatter({
    matterTitle: "",
    matterIncidentAddressStreet1: "",
    matterIncidentAddressStreet2: "",
    matterIncidentAddressCity: "",
    matterIncidentAddressState: "",
    matterIncidentAddressZip: "",
    matterIncidentAddressCounty: "",
    matterIncidentAddressCountry: "",
    matterClientInjuryDescription: "",
    matterDateOfLoss: "",
    matterDateRetained: "",
    matterFiledDate: "",
    matterContactConnection: [],
    medicalTreatments: [],
    matterInsurance: [],
    matterVehicle: [],
    matterExpense: [],
    liens: [],
    matterSettlementOffer: [],
    matterSettlementCounter: [],
    medicalTreatmentBills: [],
    matterAssignee: [],
    medicalTreatmentAppointments: [],
    medicalTreatmentRecords: [],
    medicalTreatmentAppointmentConnections: [],
    matterNote: [],
    matterTask: [],
    propertyDamages: [],
    matterSettlementDemand: [],
    matterSettlementDemandPackageSegment: [],
    matterTrustCheck: [],
    matterFile: [],
    matterFileReference: [],
    matterLostWages: [],
  } as Partial<Matter>);
}
